import { mapState } from 'vuex'
import { sharedLocalListPropsMixin } from './shared-local-list-props'

export const localListMixin = {
  mixins: [ sharedLocalListPropsMixin ],

  props: {
    allowedAdvancedFilters: {
      type: Array,
      required: false,
      default: () => []
    },
    propFilters: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  emits: ['paginate'],

  computed: {
    ...mapState(['filters', 'detailedLocations']),

    locationQuery() {
      const locationFilter = this.filters.find(f => f.type === 'location')
      if (locationFilter !== undefined) {
        return locationFilter.value
      } else {
        return null
      }
    },

    showAdvancedFilters() {
      return this.allowedAdvancedFilters.length > 0
    },

    typeQuery() {
      const typeFilter = this.filters.find(f => f.type === 'types')
      if (typeFilter !== undefined) {
        return typeFilter.value
      } else {
        // `undefined` so the prop default value will be used
        return undefined
      }
    }
  },

  methods: {
    applyLocationFilter(query) {
      this.$store.dispatch('applyLocationFilter', query)
    },
    applyTypeFilter(types) {
      this.$store.dispatch('applyTypeFilter', types)
    },
    applyAdvancedFilterChange({key, value}) {
      this.$store.dispatch(`apply${key}Filter`, value)
    },
    onPaginate() {
      this.$emit('paginate')
    }
  }
}
